/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { DtmDocCreateRequest } from '../types/DtmDocCreate';
import type { DtmDocCreateResponse } from '../types/DtmDocCreate';

export type DtmDocsCheckDmvsPendingPozadavkyCreateRequest = DtmDocCreateRequest;
export type DtmDocsCheckDmvsPendingPozadavkyCreateResponse = DtmDocCreateResponse;

export type DtmDocsCheckDmvsPendingPozadavkyCreateQuery = {};

/**
 * POST /dmx-server/dtm_docs/check_dmvs_pending_pozadavky/
 *
 * ```yaml
 * operationId: dtm_docs_check_dmvs_pending_pozadavky_create
 * tags:
 *   - dtm_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/DtmDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/DtmDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/DtmDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DtmDocCreate'
 *     description: ''
 * ```
 */
export const dtmDocsCheckDmvsPendingPozadavkyCreateOperation = (
  rest?: DtmDocsCheckDmvsPendingPozadavkyCreateQuery | null,
) =>
  ({
    method: 'POST',
    path: `/dmx-server/dtm_docs/check_dmvs_pending_pozadavky/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/dtm_docs/check_dmvs_pending_pozadavky/' };
  };

/**
 * POST /dmx-server/dtm_docs/check_dmvs_pending_pozadavky/
 *
 * ```yaml
 * operationId: dtm_docs_check_dmvs_pending_pozadavky_create
 * tags:
 *   - dtm_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/DtmDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/DtmDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/DtmDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DtmDocCreate'
 *     description: ''
 * ```
 */
export const dtmDocsCheckDmvsPendingPozadavkyCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: DtmDocsCheckDmvsPendingPozadavkyCreateQuery;
  request: DtmDocCreateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<DtmDocCreateResponse>> => {
  const operation = dtmDocsCheckDmvsPendingPozadavkyCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
